
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotion/[id]",
      function () {
        return require("private-next-pages/promotion/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotion/[id]"])
      });
    }
  